import { IFormService } from "../../service/form/FormService";

export default class GetPortalFormsInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(reportingPeriodApplicantId: number, languageCode: number) {
    return this.formService.getPortalForms(
      reportingPeriodApplicantId,
      languageCode
    );
  }
}
